
import React from 'react';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

interface BlogStatusTabsProps {
  onStatusChange: (status: string) => void;
}

const BlogStatusTabs: React.FC<BlogStatusTabsProps> = ({ onStatusChange }) => {
  return (
    <Tabs defaultValue="all" className="mb-6">
      <TabsList>
        <TabsTrigger value="all" onClick={() => onStatusChange('all')}>
          All
        </TabsTrigger>
        <TabsTrigger value="published" onClick={() => onStatusChange('published')}>
          Published
        </TabsTrigger>
        <TabsTrigger value="draft" onClick={() => onStatusChange('draft')}>
          Drafts
        </TabsTrigger>
        <TabsTrigger value="scheduled" onClick={() => onStatusChange('scheduled')}>
          Scheduled
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
};

export default BlogStatusTabs;
